<!-- 
    FORM PARA INCLUSAO DE NOVOS PARTICIPANTES NO NEGOCIO

    <crm-negocio-agenda ref="agenda" 
        @update="updateAgenda"
        @delete="updateAgenda"
        :params="{ 
                    negocio: negociocrm, 
                    lead: leadcrm, 
                    organizacao: organizacao, 
                    pessoa: pessoa, 
                    listAgenda: negociocrm.agenda, 
                    listAgendaShow: negociocrm.agenda, 
                    delete: true, 
                    edit: true 
                  }"></crm-negocio-agenda>

-->

<script>
import Vue from 'vue';
import { SysVars } from '../main';
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import apiCrm from '../api/api-crm.js'
import AgendaForm from '../forms/agenda-form'

export default {
    props: {
        params: {},
    },
    
    components: {
        AgendaForm
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            showFormAgenda: false,
            codagenda: null,
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {

        listAgenda: function () {
            if (this.params.listAgendaShow)
              return this.params.listAgendaShow
            else
              return this.params.listAgenda
        },

        paramsAgenda: function () {
            return { negocio: this.params.negocio, lead: this.params.lead, organizacao: this.params.organizacao, pessoa: this.params.pessoa }        
        },

    },

    methods: {
        handleIncluirAgenda (codagenda) {
            //abre a tela de edicao
            this.crud = SysVars.crudI 
            this.codagenda = null
            this.showFormAgenda = true;
        },

        handleEditAgenda (codagenda) {
            //abre a tela de edicao
            this.crud = SysVars.crudU //operacao de edicao
            this.codagenda = codagenda
            this.showFormAgenda = true; //exibe o form de agenda
        },

        closeFormAgenda (agenda) {
            this.showFormAgenda = false

            if (agenda) {
                let index = -1
                for (var x = 0; x < this.params.listAgenda.length; x++) {
                    if (this.params.listAgenda[x].codagenda == agenda.codagenda)
                      index = x
                }
                if (index >= 0) {
                    this.params.listAgenda[index].concluida = agenda.concluida
                    this.params.listAgenda[index].texto = agenda.texto
                    this.params.listAgenda[index].titulo = agenda.titulo
                }
                else
                    this.params.listAgenda.push(agenda)
            }

            this.$emit('update', agenda)
        },

        handleDeleteAgenda (codagenda) {
            let index = null
            for (var x = 0; x < this.params.listAgenda.length; x++) {
                if (this.params.listAgenda[x].codagenda == codagenda)
                  index = x
            }
            if (confirm("Confirma a exclusão?")) {
                this.params.listAgenda.splice(index, 1)
                this.apiAgendaDelete(codagenda).then(
                    this.$emit('delete', this.params.listAgenda[x])
                )
            }
        },

    },

    watch: {

    },

    mounted () {
    },

    created () {

    }

}

</script>

<template>
    <div class="w-100 mt-2">
        <div class="mb-2" v-for="(item, index) in listAgenda" :key="index">
            <div class="align-items-center" style="display: flex;">
                <div class="col-1 text-center">
                    <i v-if="item.tpagenda == 'L'" class="fa fa-phone lbl-deal-subtitle"></i>
                    <i v-if="item.tpagenda == 'V'" class="fa fa-car lbl-deal-subtitle"></i>
                    <i v-if="item.tpagenda == 'A'" class="fa fa-tasks lbl-deal-subtitle"></i>
                </div>
                <div class="card p-2 col-11">
                    <div class="w-100">
                        <v-button v-if="params.delete" :link="true" icon="fa-trash" class="float-right" @click="handleDeleteAgenda(item.codagenda)"></v-button>
                        <v-button v-if="params.edit" :link="true" icon="fa-pencil" class="float-right" @click="handleEditAgenda(item.codagenda)"></v-button>
                        <span class="data-list"><strong>{{ item.titulo }}</strong></span>
                    </div>
                    <div class="w-100">
                        <span class="lbl-list pr-3" :class=" {'atrasado': item.dias_atraso > 0 && item.concluida!='S' } "><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.dataagendada | formatDataHoraExtenso }} </span>
                        <span class="lbl-list pr-3"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i>{{ item.usuario_nome }}</span>
                        <span class="badge badge-green mb-2 float-right" v-if="item.concluida=='S'" >Atividade Concluída</span>
                    </div>
                    <!-- <div v-if="item.texto" class="w-100 mb-2">
                        <span class="lbl-list w-100">{{ item.texto }}</span>
                    </div> -->
                    <div class="w-100">
                        <a v-if="item.pessoa_nome" class="lbl-list mr-2" :href="'#/crm/pessoa/'+item.codpessoa"><i class="fa fa-user mr-2" aria-hidden="true"></i>{{ item.pessoa_nome }}</a>
                        <a v-if="item.org_nome" class="lbl-list mr-2" :href="'#/crm/organizacao/'+item.codorg"><i class="fa fa-university mr-2" aria-hidden="true"></i>{{ item.org_nome }}</a>
                        <a v-if="item.negocio_titulo" class="lbl-list mr-2" :href="'#/crm/negocio/'+item.codnegocio"><i class="fa fa-dollar mr-2" aria-hidden="true"></i>{{ item.negocio_titulo }}</a>
                    </div>
                </div>
            </div>
        </div>
        <agenda-form v-if="showFormAgenda" :index="codagenda" :crud="crud" :params="paramsAgenda" @closeform="closeFormAgenda"></agenda-form>
    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-negocio-agenda.vue